<template>
  <div>
    <b-card>
      <error-alert
        v-if="error"
        :error="error"
      />
      <b-row>
        <b-col md="12">
          <Types
            ref="replyTypes"
            :tab-i="tabTypeIndex"
            :is-facebook="false"
            :is-bot="true"
          />
        </b-col>
      </b-row>
      <hr>
      <div class="text-center">
        <b-button
          variant="primary"
          :disabled="submitting"
          @click="submit()"
        >
          <b-spinner
            v-if="submitting"
            small
            class="mr-50"
          />
          {{ $t('forms.save') }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BCard, BRow, BCol, BButton, BSpinner,
} from 'bootstrap-vue'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import Types from '@/views/owner-fb/reply/components/templates/ReplyTypes'
import ReplyMixin from '@/mixins/reply-mixin'
import ChatBotApi from '@/api/bot'

export default {
  name: 'BotReplyForm',
  components: {
    ErrorAlert,
    Types,
    BCard,
    BSpinner,
    BButton,
    BRow,
    BCol,
  },
  mixins: [ReplyMixin],
  props: {
    keyword: {
      type: String,
      default: 'story-mentions',
    },
    isDirect: {
      type: [Boolean, Number],
      default: false,
    },
    accountId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      submitting: false,
      error: null,
      enabled: false,
    }
  },
  computed: {
    ...mapGetters({
      currentAccount: 'instagram/currentAccount',
      form: 'bot/form',
      tabTypeIndex: 'bot/tabTypeIndex',
    }),
  },
  methods: {
    async submit() {
      this.error = null
      try {
        await this.$refs?.replyTypes?.$refs[this.form.message_type][0].submit()
      } catch (e) {
        this.error = this.$tc('errors.field-invalid', 1)
        return
      }
      const form = {
        bot_name: this.form.bot_name,
        id: this.form?.id,
        media_type: 'ig',
        is_direct: this.isDirect,
        keyword_type: this.keyword,
        typing_on_settings: this.form.typing_on_settings,
        delay_in_reply: this.form.delay_in_reply,
        template_type: this.form.message_type,
        replies: [{ template_type: this.form.message_type, reply: this.getReplyMessage() }],
      }
      if (this.accountId) form.account_id = this.accountId
      this.submitting = true
      // For direct Instagram accounts, page is null, so use account_id or 0 as pageId
      const pageId = this.currentAccount.page?.id ?? this.currentAccount.id ?? 0
      await ChatBotApi.addReply(pageId, form).then(async res => {
        if (res.error === 0) {
          this.$notifySuccess(res.message)
        }
      }).catch(e => { this.error = e })
        .finally(() => { this.submitting = false })
    },

  },
}
</script>

<style scoped>

</style>
